export function invariant(cond: any, msg: string, extra?: any) {
  if (!cond) {
    console.error('INVARIANT_FAILED', msg, extra ?? {});
    throw new Error(`INVARIANT_FAILED: ${msg}`);
  }
}

